import {
   fetchMembersTagsStart,
   fetchMembersTagsCompleted,
   fetchMembersTagsFailed,
   fetchNewMembersTagsStart,
   fetchNewMembersTagsCompleted,
   fetchNewMembersTagsFailed,
   tagsByFiltersStart,
   tagsByFiltersFailed,
   tagsByFiltersCompleted,
   addNewTagStart,
   addNewTagCompleted,
   addNewTagFailed,
   updateMembersTagStart,
   updateMembersTagCompleted,
   updateMembersTagFailed,
   deleteMembersTagStart,
   deleteMembersTagCompleted,
   deleteMembersTagFailed,
   deleteMembersTagsStart,
   deleteMembersTagsCompleted,
   deleteMembersTagsFailed,
} from './actions'
import {
   initMembersTags,
   deleteMembersTag,
   addMembersTag,
   updateMembersTag,
   deleteTags,
}  from 'admin/api/AuthApi';
import toster from 'common/utils/toast';


export const fetchMembersTagsOperation = (query) => {
   return async (dispatch) => {
      dispatch(fetchMembersTagsStart());
      try {
         const { data } = await initMembersTags(query);
         let payload = data

         // If 'count=all' query added the data is [] not paginated structure with {data: []}
         if(Array.isArray(data)) {
            payload = {
               data,
            }
         }
         dispatch(fetchMembersTagsCompleted(payload));
      } catch (error) {
         dispatch(fetchMembersTagsFailed(error.response));
      }
   };
};

export const fetchNewMembersTagsOperation = (query) => {
   return async (dispatch) => {
      dispatch(fetchNewMembersTagsStart());
      try {
         const { data } = await initMembersTags(query);
         dispatch(fetchNewMembersTagsCompleted(data));
      } catch (error) {
         dispatch(fetchNewMembersTagsFailed(error.response));
      }
   };
};

export const fetchTagsByFilter = (query, filter) => {
   return async (dispatch) => {
      dispatch(tagsByFiltersStart(filter));
      try {
         const { data } = await initMembersTags(query);
         dispatch(tagsByFiltersCompleted(data));
      } catch (error) {
         dispatch(tagsByFiltersFailed(error.response));
      }
   };
};


export const addNewTagOperation = (data, callback) => {
   return async (dispatch) => {
      dispatch(addNewTagStart())
      try {
         const response = await addMembersTag(data);
         dispatch(addNewTagCompleted(response.data));
         if(callback) {
            callback()
         }
      } catch (error) {
         dispatch(addNewTagFailed(error.response));
      }
   }
}

export const updateMembersTagOperation = (id, data) => {
   return async (dispatch) => {
      dispatch(updateMembersTagStart())
      try {
         await updateMembersTag(id, data);
         dispatch(updateMembersTagCompleted(id, data));
      } catch (error) {
         dispatch(updateMembersTagFailed(error.response));
      }
   }
}

export const deleteMembersTagOperation = (id) => {
   return async (dispatch) => {
      dispatch(deleteMembersTagStart())
      try {
         await deleteMembersTag(id);
         dispatch(deleteMembersTagCompleted(id));
         toster.info('Member tag has been removed');
      } catch (error) {
         dispatch(deleteMembersTagFailed(error.response));
      }
   }
}

export const bulkDeleteMembersTagsOperation = (data) => {
   return async (dispatch) => {
      dispatch(deleteMembersTagsStart())
      try {
         await deleteTags(data);
         dispatch(deleteMembersTagsCompleted(data));
         toster.info('Your changes have been saved');
      } catch (error) {
         dispatch(deleteMembersTagsFailed(error.response));
      }
   }
}
